import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, MessageSquare, BookOpen, BarChart2, FileText, Megaphone, Settings, Check, X, ChevronRight } from 'lucide-react';
// Notification types with their respective icons
const notificationIcons = {
  message: MessageSquare,
  forum: MessageSquare,
  homework: BookOpen,
  report: BarChart2,
  document: FileText,
  announcement: Megaphone,
  system: Bell
};
interface Notification {
  id: string;
  type: keyof typeof notificationIcons;
  title: string;
  message: string;
  time: string;
  read: boolean;
  link: string;
}
interface NotificationPanelProps {
  notifications: Notification[];
  onClose: () => void;
  onMarkAllAsRead: () => void;
}
export function NotificationPanel({
  notifications,
  onClose,
  onMarkAllAsRead
}: NotificationPanelProps) {
  const unreadCount = notifications.filter(n => !n.read).length;
  return <div className="absolute right-0 top-16 w-80 sm:w-96 bg-black/95 border border-purple-500/30 rounded-xl shadow-xl z-50 overflow-hidden" data-id="element-244">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-245">
        <div className="relative bg-black/90 rounded-xl" data-id="element-246">
          {/* Header */}
          <div className="p-4 border-b border-purple-500/20 flex items-center justify-between" data-id="element-247">
            <div className="flex items-center gap-2" data-id="element-248">
              <h3 className="font-bold text-white" data-id="element-249">Bildirimler</h3>
              {unreadCount > 0 && <span className="bg-blue-500 text-white text-xs rounded-full px-2 py-0.5" data-id="element-250">
                  {unreadCount} yeni
                </span>}
            </div>
            <div className="flex items-center gap-3" data-id="element-251">
              {unreadCount > 0 && <button onClick={onMarkAllAsRead} className="text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1" data-id="element-252">
                  <Check className="w-3 h-3" data-id="element-253" />
                  <span data-id="element-254">Tümünü Okundu İşaretle</span>
                </button>}
              <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-255">
                <X className="w-5 h-5" data-id="element-256" />
              </button>
            </div>
          </div>
          {/* Notification List */}
          <div className="max-h-[400px] overflow-y-auto custom-scrollbar" data-id="element-257">
            {notifications.length > 0 ? <div className="divide-y divide-gray-800/50" data-id="element-258">
                {notifications.map(notification => {
              const Icon = notificationIcons[notification.type] || Bell;
              return <Link key={notification.id} to={notification.link} className={`block p-4 hover:bg-white/5 transition-colors ${!notification.read ? 'bg-purple-500/10' : ''}`} onClick={onClose} data-id="element-259">
                      <div className="flex gap-3" data-id="element-260">
                        <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${!notification.read ? 'bg-purple-500/20 text-purple-400' : 'bg-gray-800 text-gray-400'}`} data-id="element-261">
                          <Icon className="w-5 h-5" data-id="element-262" />
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-263">
                          <div className="flex justify-between items-start mb-1" data-id="element-264">
                            <p className={`text-sm font-medium ${!notification.read ? 'text-white' : 'text-gray-300'}`} data-id="element-265">
                              {notification.title}
                            </p>
                            <span className="text-xs text-gray-500 whitespace-nowrap ml-2" data-id="element-266">
                              {notification.time}
                            </span>
                          </div>
                          <p className="text-xs text-gray-400 line-clamp-2" data-id="element-267">
                            {notification.message}
                          </p>
                        </div>
                      </div>
                    </Link>;
            })}
              </div> : <div className="py-8 text-center" data-id="element-268">
                <Bell className="w-12 h-12 text-gray-700 mx-auto mb-3" data-id="element-269" />
                <p className="text-gray-500" data-id="element-270">Bildiriminiz bulunmuyor</p>
              </div>}
          </div>
          {/* Footer */}
          <div className="p-3 border-t border-purple-500/20 flex justify-between" data-id="element-271">
            <Link to="/yonetici/bildirimler" className="text-sm text-blue-400 hover:text-blue-300 flex items-center gap-1" onClick={onClose} data-id="element-272">
              <span data-id="element-273">Tüm Bildirimleri Gör</span>
              <ChevronRight className="w-4 h-4" data-id="element-274" />
            </Link>
            <Link to="/yonetici/bildirim-ayarlari" className="text-sm text-gray-400 hover:text-gray-300 flex items-center gap-1" onClick={onClose} data-id="element-275">
              <Settings className="w-4 h-4" data-id="element-276" />
              <span data-id="element-277">Bildirim Ayarları</span>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}